// extracted by mini-css-extract-plugin
export default {"sectionsList":"SectionsList_sectionsList__shQVC"};